export const props = {
  // Values
  list: Array,
  underline: String,
  group: Object,

  // Status
  focus: undefined,
  selected: [Array, Number, String],

  // Options
  color: undefined,
  tag: undefined,
  size: undefined,
  border: undefined,
  marginItem: {
    type: String,
    default: null
  },
  on: undefined,
  itemAttrs: Object
}
